export default "__VITE_ASSET__b94wFSji__"